import { Image } from "@/components/common/Image"

export const Loading = () => (
  <div className="loading">
    <Image src="logo-vert.svg" className="min-h-24" />
  </div>
)
